import React, { memo, useEffect, useRef, useState } from 'react';
import { useUser } from 'src/components/hooks/useUser';
import { useGetAssigneesMutation } from 'src/services/Utils';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useIMVReportPage } from './UseIMVReportPage';
import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import AppModal from 'src/components/modal';
import forms from '../../../resources/forms.json';
import Loader from 'src/components/common/Loader';


const IMVReportSendForReview: React.FunctionComponent<any> = props => {
  const {
    handleCloseSendForReview,
    openSendForReviewDialog,
    monitoring_visit_id: monitoringVisitId,
    getImvReportData
  } = props;
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const dispatch = useAppDispatch();
  const { user } = useUser();
  const updateSignaturePermission = `UPDATE_SIGNATURE_IMVREPORT`;
  const [
    getUser,
    { data: userData, isError: userDataIsError, isSuccess: userDataIsSuccess, isLoading: userDataIsLoading }
  ] = useGetAssigneesMutation();
  const sendForReviewForm = forms.sendForReviewIMVreport;
  const { formFields, defaultValues = {}, rules } = getFormData(sendForReviewForm.groups);
  const { groups } = formFields;
  const formRef: any = useRef(null);
  const {
    sendForReviewFunc,
    sendForReviewError,
    sendForReviewIsLoading,
    sendForReviewIsError,
    sendForReviewIsSuccess
  } = useIMVReportPage();

  const [group,setGroup] = useState(groups);

  const handleConfirmSendForReview = () => {
    formRef.current.submit(onFormSubmit);
  };

  const onFormSubmit = async (data: any) => {
    if (data.errors) {
      dispatch(setMessage({ msgDetails: 'Mandatory Information is Missing.', severity: 'error' }));
      return;
    }
    if (data.success) {
       const userName= data.records.notify_user.split(' (')
      await sendForReviewFunc({
        site_id: selectedSite,
        study_id: studyId,
        data: {
          notify_user: userName?.[0],
          updated_by: user
        },
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        monitoring_visit_id: monitoringVisitId
      });
      handleCloseSendForReview();
      getImvReportData();
    }
  };

  useEffect(() => {
    if (!userDataIsLoading && userDataIsError) {
      dispatch(setMessage({ msgDetails: 'Unable to get the users', severity: 'error' }));
    } else if (userData && userDataIsSuccess && !userDataIsLoading) {
      const updatedGroups = groups.map((obj: any) => {
        return {
          ...obj,
          fields: obj.fields.map((field: any) => {
            if (field.name === 'notify_user' && !userDataIsLoading && userDataIsSuccess && userData?.length >= 3) {
              field.values = userData.map((ele: any) => `${ele.first_name} ${ele.last_name} (${ele.email})`);
            }
            return field;
          })
        };
      });
       setGroup(updatedGroups);
    }
  }, [userData, userDataIsLoading, userDataIsError]);

  useEffect(() => {
   getUser({
       client_name: 'ctms-ui',
       data: [updateSignaturePermission]
     });
   }, []);

  useEffect(() => {
    if (sendForReviewIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: 'Report is sent for review successfully.',
          severity: 'success'
        })
      );
    }
  }, [sendForReviewIsSuccess]);

  useEffect(() => {
    if (sendForReviewIsLoading || userDataIsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [sendForReviewIsLoading, userDataIsLoading]);

  useEffect(() => {
    if (sendForReviewIsError) {
      const err: any = sendForReviewError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: 'Error',
            severity: 'error'
          })
        );
      }
    }
  }, [sendForReviewIsError]);

  return (
    <>
      <AppModal
        open={openSendForReviewDialog}
        title={sendForReviewForm.header}
        child
        saveButton={'OK'}
        closeButton={'Cancel'}
        handleSubmit={handleConfirmSendForReview}
        handleClose={() => handleCloseSendForReview()}
        maxWidth="400px"
      >
        <Loader />
        <FormLayoutBuilder
          initialValues={defaultValues}
          rules={rules}
          ref={formRef}
          groups={group}
          columnSpacing={2}
        />
      </AppModal>
    </>
  );
};

export default memo(IMVReportSendForReview);
